import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';

export function buildExternalLink(invitation: ExternalInvitation) {
  return `${invitation.scopeUrl}?code=${invitation.code}`;
}
